import Reveal from "./Reveal";

const areas = [
  { name: "The Hamptons", detail: "Southampton · East Hampton · Montauk · Sag Harbor" },
  { name: "New York City", detail: "Manhattan · Brooklyn · Queens · The Bronx" },
  { name: "JFK International", detail: "Meet & greet · flight tracking" },
  { name: "LaGuardia (LGA)", detail: "Curbside & terminal pickups" },
  { name: "Newark (EWR)", detail: "Tri-state transfers" },
  { name: "Teterboro / Private", detail: "Private jet FBO transfers" },
];

const IMG = "https://images.unsplash.com/photo-1432462770865-65b70566d673";

export const ServiceAreas = () => (
  <section id="areas" className="max-w-[1400px] mx-auto px-6 lg:px-10 py-28 lg:py-40">
    <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
      <div className="lg:col-span-5 lg:sticky lg:top-28">
        <Reveal>
          <p className="overline mb-5">03 — Where We Drive</p>
          <h2 className="font-serif text-4xl lg:text-6xl tracking-tight leading-tight">
            From the dunes of Montauk to the tarmac at JFK.
          </h2>
          <div className="mt-8 overflow-hidden">
            <img
              src={IMG}
              alt="Chauffeur interior"
              className="w-full aspect-[4/3] object-cover grayscale-[20%]"
            />
          </div>
        </Reveal>
      </div>

      <div className="lg:col-span-7">
        <div className="grid grid-cols-1 sm:grid-cols-2 border-t border-l border-white/10">
          {areas.map((a, i) => (
            <Reveal key={a.name} delay={i * 0.08}>
              <div
                data-testid={`area-${i}`}
                className="group border-b border-r border-white/10 p-8 hover:bg-surface transition-colors duration-400 h-full"
              >
                <span className="overline text-[#8A8A8A] group-hover:text-gold transition-colors">
                  0{i + 1}
                </span>
                <h3 className="font-serif text-3xl mt-3 mb-2">{a.name}</h3>
                <p className="text-sm text-[#8A8A8A] font-light">{a.detail}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default ServiceAreas;
